module.exports = __webpack_public_path__ + "static/PWX Logo-a19fb0afc9c0a07bf1ad6255ec2067f3.png";